<form #form="ngForm" (ngSubmit)="submit(exportDataIntervalControl.value)">
  <div class="modal-body">
    <div class="form-group">
      <label for="data-interval" class="form-label">{{message | messageTranslate}}</label>
      <div class="input-group">
        <input id="data-interval"
               name="interval"
               type="number"
               class="form-control"
               [formControl]="exportDataIntervalControl" />
        &nbsp; {{'Minutes' | messageTranslate}}
      </div>
      <app-errors [control]="exportDataIntervalControl"/>
    </div>
  </div>
  <div class="modal-footer">
    <app-button type="submit" visual="primary" label="OK" [disabled]="!exportDataIntervalControl.valid"/>
    <app-button type="button" visual="secondary" label="Cancel" (buttonClick)="cancel()"/>
  </div>
</form>
